/**
 * editor_plugin_src.js
 *
 * Copyright 2009, Moxiecode Systems AB
 * Released under LGPL License.
 *
 * License: http://tinymce.moxiecode.com/license
 * Contributing: http://tinymce.moxiecode.com/contributing
 */
tinymce.PluginManager.add('comments', function(ed, e) {
    var t = this;
    t.win = window;
    t.commentCls = "ed-comments";
    t.addCommentButton = function () { };
    t.removeCommentButton = function () { };
    t.removeAllCommentsButton = function () { };
    
    t.openCommentWindow = function (ed) { 
        var t = this;
        var text = ed.selection.getContent();
        var node = ed.selection.getNode();
        var nodeClass = $(node).attr("class");
        var id = 'edCommentTempId';
        if(nodeClass !== t.commentCls) {
            ed.selection.setNode(ed.dom.create('span', {'id' : id, 'class' : t.commentCls}, text));
        } else {
            id = $(node).attr("id");
        }
        t.win.getComments(ed.id, id);
    };
    
    ed.on('init', function(){
        var t = this;
        t.commentClsSelector = '.' + t.commentCls;
        
    });
    
    ed.addButton('addComment', {
        name: 'addComment',
        icon: ' glyphicon glyphicon-comment',
        tooltip: 'Add Comment',
        disabled: true,
        onclick: function(){
            t.win.clearComments(ed.id, false, true);
            t.openCommentWindow(ed);
        },
        onPostRender: function () { 
            var self = this;
            ed.plugins.ezdia.addCommentButton = self;
            ed.plugins.ezdia.addCommentButton.disabled = self.disabled;

            ed.on('NodeChange', function () {
                var tx = ed.selection.getContent();
                if (tx) {
                    self.disabled(false);
                } else {
                    self.disabled(true);
                }
            }); 
        }
    });
    
    ed.addButton('removeCommentAll', {
        name: 'removeCommentAll',
        icon: ' glyphicon glyphicon-erase',
        tooltip: 'Clear all comments',
        disabled: true, 
        onclick: function(){
            t.clearAll = true;
            t.win.cleanEditorComments(t.comments);
        },
        onPostRender: function () { 
            var self = this;
            ed.plugins.ezdia.removeAllCommentsButton = self;
            ed.plugins.ezdia.removeAllCommentsButton.disabled = self.disabled;

            ed.on('NodeChange', function () {
                var tx = ed.getContent();
                if (hasCommentClsTag(tx)) {
                    self.disabled(false);
                } else {
                    self.disabled(true);
                }
            }); 
        }
    });
    
    ed.addButton('removeComment', {
        name: 'removeComment',
        icon: ' glyphicon glyphicon-erase',
        tooltip: 'Clear comments',
        disabled: true,
        onclick: function(){
            t.clearAll = false;
            t.win.cleanEditorComments(t.comments);
        },
        onPostRender: function () { 
            var self = this;
            ed.plugins.ezdia.removeCommentsButton = self;
            ed.plugins.ezdia.removeCommentsButton.disabled = self.disabled;

            ed.on('NodeChange', function (e) {
                var tx = ed.selection.getContent();
                if (isInsideCommentClsTag(e.element) || hasCommentClsTag(tx)) {
                    self.disabled(false);
                } else {
                    self.disabled(true);
                }
            }); 
        }
    });
    

    /**
     * Private Methods
     */

    var isInsideCommentClsTag = function(n) {
        return !!ed.dom.getParent(n, t.commentClsSelector);
    };
    
    var hasCommentClsTag = function(tx) {
        var hasCls = $('<div>' + tx + '</div>').find(t.commentClsSelector).length;
        return (hasCls != 0) ? true : false;
    };
    
    
});